import moment from 'moment'

export default {
    install(Vue) {
        Vue.prototype.myMoment = function (date) {
            return  moment.utc(date).format("YYYY-MM-DD HH:mm");
        }
    },
    toLowerLine
}

/**
 * 驼峰转下划线
 * @param str
 * @returns {*}
 */
function toLowerLine(str) {
    let temp = str.replace(/[A-Z]/g, function (match) {
        return "_" + match.toLowerCase();
    });
    if(temp.slice(0,1) === '_'){ //如果首字母是大写，执行replace时会多一个_，这里需要去掉
        temp = temp.slice(1);
    }
    return temp;
};
// console.log(toLowerLine("TestToLowerLine"));  //test_to_lower_line
// console.log(toLowerLine("testToLowerLine"));  //test_to_lower_line